export default __webpack_public_path__ + "static/media/01.cb8a7159.jpeg";